import { TextSize } from '@/types';

/**
 * Text size presets mapping to pixel values
 */
export const TEXT_SIZE_MAP = {
    [TextSize.SMALL]: 10,
    [TextSize.MEDIUM]: 14,
    [TextSize.LARGE]: 20,
} as const;

/**
 * Default text size for new text markups
 */
export const DEFAULT_TEXT_SIZE = TextSize.MEDIUM;
